import { Grid, InputLabel, Typography, Box, FormHelperText, Button, Avatar } from '@mui/material'
import { BootstrapTooltip } from '../../ReusableComponents.js/ToolTip/ToolTipComponent'
import { clearInputValue } from 'Components/ReusableComponents.js/reuseMethods'
import './CreateInitiativeUploadCoverImageInputField.css'
import closeIconp from 'asserts/images/close.png'
import UploadCoverImage from '../UploadCoverImage/UploadCoverImage'
import coverclose from '../../../asserts/images/coverclose.svg'
const CreateInitiativeUploadCoverImageInputField = ({
  Id,
  acceptedImageFormatsForInitiativeCover,
  hiddenFileInput,
  onFileUpload,
  handleClick,
  imageName,
  setOpenUploadImageDialog,
  checkCoverImage,
  handleCoverRegister,
  preview,
  sendGALog,
  setImage,
  setImageName,
  setPreview,
  createNewClick,
}) => {
  const handleOpenUploadImageDialog = () => {
    setOpenUploadImageDialog(true)
  }

  const onDelete = () => {
    setImage(null)
    setImageName(null)
    setPreview(null)
  }

  return (
    <Grid item xs={10} md={10} lg={10} xl={10} sx={{ marginTop: '25px' }}>
      <InputLabel id={Id} shrink htmlFor="bootstrap-input" sx={{ color: '#2e739c' }}>
        <Typography className="headincreateini initiative-titles-st">Upload Initiative Cover Image*</Typography>
      </InputLabel>
      {preview ? (
        <Box sx={{ position: 'relative', width: '200px' }}>
          {' '}
          <Avatar
            src={createNewClick ? preview : preview?.toString().startsWith('blob') ? preview : JSON.parse(preview)[0]}
            alt=""
            className="form-img__img-preview-4 "
            sx={{
              display: 'block',
              width: '150px',
              height: '150px',
              objectFit: 'cover',
              borderRadius: '20px',
            }}
          />
          <Avatar
            src={closeIconp}
            onClick={onDelete}
            className="imageclose-2-spac1-cover"
            sx={{
              width: '22px',
              height: '22px',
              padding: '5px',
            }}
          />
        </Box>
      ) : (
        <BootstrapTooltip
          title="Accepted file formats for open & zip uploads : .jpg, .jpeg, .jpe, .jif, .jfif, .jfi, .png, .tiff, .psd, .eps, .ai, .indd, .raw, .webp, .svg, .svgz, .heif"
          placement="right-start"
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: '18px',
                fontFamily: 'HK Grotesk',
                padding: '15px',
              },
            },
          }}
          className="mg-t-1"
        >
          <Box className="cls-input-sty texcretei" sx={{ width: '421px' }}>
            <input
              type="file"
              accept={acceptedImageFormatsForInitiativeCover}
              ref={hiddenFileInput}
              className="in-st-div"
              onChange={onFileUpload}
              onClick={clearInputValue}
              required
            />
            <Box className="div-pre">
              <Button
                id="select_cover_image"
                onClick={(e) => {
                  if (!preview) {
                    sendGALog('browse')
                    handleClick(e, true)
                  } else {
                    handleOpenUploadImageDialog()
                  }
                }}
                className="div-br-pr"
              >
                {preview ? 'Preview' : 'Browse'}
              </Button>
              {imageName ? (
                <Typography
                  sx={{ display: 'block', fontSize: '14px' }}
                  className="ellipsewehe"
                  onClick={handleOpenUploadImageDialog}
                >
                  {'wrnfeirf'}
                </Typography>
              ) : null}
            </Box>
            <FormHelperText sx={{ color: '#d32f2f', marginTop: '6px', fontWeight: '700' }}>
              {checkCoverImage && !imageName && 'Please upload a cover image'}
            </FormHelperText>
          </Box>
        </BootstrapTooltip>
      )}
    </Grid>
  )
}

export default CreateInitiativeUploadCoverImageInputField
